import { observer } from "mobx-react";
import ButtonBack from "newApp/components/ButtonBack";
import CategoryForm from "newApp/components/CategoryForm";
import MainLayout from "newApp/components/layouts/MainLayout";
import Button from "newApp/kit/components/Button";
import ButtonsContainer from "newApp/kit/components/ButtonsContainer";
import FlexColumn from "newApp/kit/components/FlexColumn";
import H1 from "newApp/kit/components/H1";
import { URL_ADMINISTRATION_CATEGORIES } from "newApp/routing/urls";
import { CategoryEditPageStore } from "newApp/stores/pages/administrations/categories/CategoryEditPageStore";
import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router";

const store = new CategoryEditPageStore();

const CategoryEditPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { push } = useHistory();
  useEffect(() => {
    if (id) store.init(id);
    return () => store.reset();
  }, [id]);

  const onClickCreate = async () => {
    const result = await store.onSave();
    if (result) goOnList();
  };

  const goOnList = () => push(URL_ADMINISTRATION_CATEGORIES);

  return (
    <MainLayout isLoading={store.isLoadings.getCategory}>
      <H1>Редактирование категории</H1>
      <FlexColumn>
        <ButtonBack url={URL_ADMINISTRATION_CATEGORIES}>
          Назад к списку
        </ButtonBack>
        <CategoryForm {...store} />
        <ButtonsContainer>
          <Button onClick={onClickCreate}>Сохранить изменения</Button>
          <Button onClick={goOnList} variant="secondary">
            Отменить
          </Button>
        </ButtonsContainer>
      </FlexColumn>
    </MainLayout>
  );
};

export default observer(CategoryEditPage);
